
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes07Off as ObiDiodes07OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-07-off.js';
 
 
 

 
 export const ObiDiodes07Off = createComponent({
   react: React,
   tagName: 'obi-diodes-07-off',
   elementClass: ObiDiodes07OffElement,
   events: {
     
   }
  });
 
 